<form [formGroup]="formGroup">
  <div class="color-canvas-row">
    <div class="zone-canvas">
      <canvas id="color-block" class="zone-block" (mousedown)="onMousedown($event)" (mouseup)="onMouseup($event)" width="220" height="200"></canvas>
      <ngx-mat-color-slider (colorChanged)="onSliderColorChanged($event)"></ngx-mat-color-slider>
    </div>

    <div *ngIf="showRGBA" class="zone-inputs">
      <mat-form-field mcColor="secondary">
        <mat-label>R</mat-label>
        <input matInput formControlName="r" ngxMatNumericColorInput autocomplete="off">
      </mat-form-field>

      <mat-form-field mcColor="secondary">
        <mat-label>G</mat-label>
        <input matInput formControlName="g" ngxMatNumericColorInput autocomplete="off">
      </mat-form-field>

      <mat-form-field mcColor="secondary">
        <mat-label>B</mat-label>
        <input matInput formControlName="b" ngxMatNumericColorInput autocomplete="off">
      </mat-form-field>
    </div>
  </div>

  <div class="color-canvas-row">
    <button mat-mini-fab [style.background-color]="color?.rgba || 'transparent'" class="preview"></button>
    <mat-form-field mcColor="secondary" floatLabel="always">
      <mat-label>Color</mat-label>
      <span matTextPrefix>#&nbsp;</span>
      <input matInput formControlName="hex" autocomplete="off" placeholder="HEX6">
    </mat-form-field>
    <mat-form-field *ngIf="showRGBA" mcColor="secondary" floatLabel="always">
      <mat-label>Alpha</mat-label>
      <input matInput formControlName="a" type="number" min="0" max="1" step="0.1" autocomplete="off" placeholder="A">
    </mat-form-field>
  </div>
</form>